import { ref, watch } from 'vue';
import { defineStore } from 'pinia';

// // Utils imports
import BeaconManager from '@/utils/beaconManager';

export const useTrackerStore = defineStore('tracker', () => {
  const trackerBeacon = ref({
    beaconManager: new BeaconManager(),
  });
  // // Tracker flags (Booleans, Nulls, & Undefineds)
  const isIframe = ref(localStorage.getItem('isIframe'));
  const isVisible = ref(localStorage.getItem('isVisible'));
  const isBreakInteracted = ref(localStorage.getItem('isBreakInteracted'));
  const isTizen = ref(localStorage.getItem('isTizen'));
  // // Tracker figures (Numbers)
  // // Tracker text (Strings)
  const trackerDuid = ref(localStorage.getItem('trackerDuid'));
  // // Tracker lists (Arrays)
  // // Tracker dictionaries (Objects)
  const trackingInfo = ref(localStorage.getItem('trackingInfo'));

  // // Actions

  const blankTracker = () => {
    // console.log(' BLANK TRACKER');

    isIframe.value = false;
    isVisible.value = false;
    isBreakInteracted.value = false;
    isTizen.value = false;
    trackerDuid.value = '';
    trackingInfo.value = {};
  };

  // // Getters

  watch(isIframe, () => {
    localStorage.setItem('isIframe', isIframe.value);
  });

  watch(isVisible, () => {
    localStorage.setItem('isVisible', isVisible.value);
  });

  watch(isBreakInteracted, () => {
    localStorage.setItem('isBreakInteracted', isBreakInteracted.value);
  });

  watch(isTizen, () => {
    localStorage.setItem('isTizen', isTizen.value);
  });

  watch(trackerDuid, () => {
    localStorage.setItem('trackerDuid', trackerDuid.value);
  });

  watch(trackingInfo, () => {
    localStorage.setItem('trackingInfo', trackingInfo.value);
  });

  return {
    trackerBeacon,
    isIframe,
    isVisible,
    isBreakInteracted,
    isTizen,
    trackerDuid,
    trackingInfo,
    blankTracker,
  };
});
